import { request } from '@/api';

const PREFIX = '/auth/token';

export interface TokenRolePermissionVO {
  /**
   * 权限编码列表
   */
  permissionCodes: string[];
  /**
   * 角色标识列表
   */
  roleKeys: string[];
}

/**
 * /token/role_permission_info
 * 获取当前登录用户的角色权限信息
 */
export const getRolePermissionInfo = () =>
  request.get<TokenRolePermissionVO>(`${PREFIX}/role_permission_info`);
